import { render, staticRenderFns } from "./Robotizationlabel.vue?vue&type=template&id=340d71a8&scoped=true&"
import script from "./Robotizationlabel.vue?vue&type=script&lang=js&"
export * from "./Robotizationlabel.vue?vue&type=script&lang=js&"
import style0 from "./Robotizationlabel.vue?vue&type=style&index=0&id=340d71a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d71a8",
  null
  
)

export default component.exports